<template>
    <div name="contract" class="contract">
        <sign-modal 
            @closeModal="closeModal"
            v-if="isModal"
        />
        <div ref="container" class="image-container">
            <img ref="image" src="../assets/contract1.png" class="responsive-image" @load="onImageLoad"/>
            <div ref="button" class="overlay-button" @click="signing" v-if="!signImageUrl">                
                <span class="button-text">서명하기</span>
            </div>
            <div ref="button" class="overlay-button" style="border: none" v-else>                
                <img :src="signImageUrl" v-if="signImageUrl" />
            </div>
        </div>
    </div>
</template>

<script>
import SignModal from '@/components/modals/SignModal'

export default {
    name: 'contract',
    data: function()
    {
        return {
            signImageUrl: null,
            isModal: false
        }
    },  
    components: {
        SignModal
    },
    mounted: function()
    {

        this.requestLocationPermission();
        // 화면 크기 변화 시 버튼 위치를 조정
        window.addEventListener("resize", this.updateButtonPosition);
        this.updateButtonPosition();
    },
    beforeDestroy: function(){
        window.removeEventListener("resize", this.updateButtonPosition);
    },
    methods: {
        requestLocationPermission() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // 위치 정보를 성공적으로 가져온 경우
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
          },
          (error) => {
            // 오류 발생 시
            switch (error.code) {
              case error.PERMISSION_DENIED:
                this.errorMessage = "사용자가 위치 권한을 거부했습니다.";
                break;
              case error.POSITION_UNAVAILABLE:
                this.errorMessage = "위치 정보를 사용할 수 없습니다.";
                break;
              case error.TIMEOUT:
                this.errorMessage = "위치 정보 요청이 시간 초과되었습니다.";
                break;
              default:
                this.errorMessage = "알 수 없는 오류가 발생했습니다.";
                break;
            }
            console.error(this.errorMessage);
          }
        );
      } else {
        this.errorMessage = "이 브라우저는 위치 서비스를 지원하지 않습니다.";
        console.error(this.errorMessage);
      }
    },
        signing: function()
        {
            this.isModal = true;
        },
        closeModal: function(signature)
        {
            this.isModal = false;
            this.signImageUrl = signature;
        },
        onImageLoad: function()
        {
            this.updateButtonPosition();
        },
        updateButtonPosition() {
            const container = this.$refs.container;
            const button = this.$refs.button;
            
            // 이미지 크기에 따라 버튼의 위치를 조정 (가령 이미지의 30%, 40% 위치에 배치)
            const offsetX = container.clientWidth * 0.105; // 원하는 비율
            const offsetY = container.clientHeight * 0.08; // 원하는 비율
            
            button.style.right = `${offsetX}px`;
            button.style.bottom = `${offsetY}px`;

        },
    }
}
</script>

<style scoped>
    .contract {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .image-container {
        position: relative;
        display: inline-block;
        width: 100%; /* 원하는 크기로 설정 */
        max-width: 1200px; /* 최대 크기 설정 */
    }
    .responsive-image {
        width: 100%;
        height: auto;
    }

    .overlay-button {
        position: absolute;
        width: 7vw;
        height: 7vw;
        border: 4px dotted black;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/page/Contract.vue